import React, { useMemo } from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const sanitizeImage = (image) => {
    if (!image) return null;
    const url = sanitize(image?.url || "");
    if (!url) return null;
    return { url, alt: sanitize(image?.alt || "") };
};

const VisitSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) {
            return null;
        }

        const eyebrow = sanitize(fields.eyebrow || "");
        const heading = sanitize(fields.heading || "");
        const mapImage = sanitizeImage(fields.map_image);
        const mapImageMobile = sanitizeImage(fields.map_image_mobile);
        const mapUrl = sanitize(fields.map_url || "");
        const mapbtntext = sanitize(fields.map_redirection_button_text || "");

        const hasContent =
            eyebrow || heading || mapImage || mapImageMobile || mapUrl;

        if (!hasContent) {
            return null;
        }

        return {
            eyebrow,
            heading,
            mapImage,
            mapImageMobile,
            mapUrl,
            mapbtntext,
        };
    }, [fields]);

    if (!sanitizedData) {
        return null;
    }

    const {
        eyebrow,
        heading,
        mapImage,
        mapImageMobile,
        mapUrl,
        mapbtntext,
    } = sanitizedData;

    return (
        <section className="visit-section page-section aos-fade-up">
            <div className="canvas visit">
                <div className="visit-section-inner">

                    {/* HEADINGS */}
                    {(eyebrow || heading) && (
                        <div
                            className="visit-sec-head"
                            data-stagger-index="0"
                        >
                            {eyebrow && (
                                <p className="small-heading">{eyebrow}</p>
                            )}
                            {heading && (
                                <h1 className="main-heading">{heading}</h1>
                            )}
                        </div>
                    )}

                    {/* MAP */}
                    {(mapImage || mapImageMobile || mapUrl) && (
                        <div
                            className="map-wrapper"
                            data-stagger-index="1"
                        >

                            {/* IMAGE ONLY IF VALID */}
                            {(mapImage || mapImageMobile) && (
                                <picture>

                                    {mapImageMobile?.url && (
                                        <source
                                            media="(max-width: 767px)"
                                            srcSet={mapImageMobile.url}
                                        />
                                    )}

                                    {mapImage?.url && (
                                        <img
                                            src={mapImage.url}
                                            alt={mapImage.alt || ""}
                                        />
                                    )}

                                </picture>
                            )}

                            {/* BUTTON ONLY IF URL EXISTS */}
                            {mapUrl && (
                                <a
                                    href={mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="map-btn"
                                >
                                    <span className="map-icon">
                                        {mapbtntext || "Get Directions"}
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="24" height="24" rx="12" fill="#093E59"></rect>
                                            <path d="M16.8968 10.6854L17.2484 11.0409C17.343 10.9473 17.3964 10.8198 17.3968 10.6868C17.3972 10.5537 17.3445 10.4259 17.2504 10.3318L16.8968 10.6854ZM7.8374 16.2682C7.83743 16.5443 8.06132 16.7681 8.33746 16.7681C8.61361 16.7681 8.83743 16.5442 8.8374 16.268L8.3374 16.2681L7.8374 16.2682ZM14.0485 7.12997C13.8532 6.93471 13.5367 6.93471 13.3414 7.12997C13.1461 7.32523 13.1461 7.64182 13.3414 7.83708L13.695 7.48353L14.0485 7.12997ZM13.3433 13.4968C13.147 13.6909 13.1453 14.0075 13.3395 14.2039C13.5336 14.4002 13.8502 14.4019 14.0466 14.2077L13.695 13.8522L13.3433 13.4968ZM13.0805 10.6854L13.0805 10.1854L13.0805 10.6854ZM16.8968 10.6854L17.2504 10.3318L14.0485 7.12997L13.695 7.48353L13.3414 7.83708L16.5433 11.0389L16.8968 10.6854ZM16.8968 10.6854L16.5452 10.3299L13.3433 13.4968L13.695 13.8522L14.0466 14.2077L17.2484 11.0409L16.8968 10.6854ZM16.8968 10.6854L16.8968 10.1854L13.0805 10.1854L13.0805 10.6854L13.0805 11.1854L16.8968 11.1854L16.8968 10.6854ZM13.0805 10.6854L13.0805 10.1854C11.9841 10.1854 11.093 10.1843 10.3993 10.2769C9.69846 10.3705 9.10375 10.5702 8.67213 11.0477C8.25132 11.5133 8.05867 12.1642 7.95741 12.9786C7.85534 13.7993 7.83721 14.8768 7.8374 16.2682L8.3374 16.2681L8.8374 16.268C8.83721 14.8677 8.85657 13.8515 8.94976 13.102C9.04375 12.3462 9.20413 11.9504 9.41399 11.7183C9.61304 11.498 9.92665 11.3489 10.5316 11.2682C11.1438 11.1864 11.9561 11.1854 13.0805 11.1854L13.0805 10.6854Z" fill="white"></path>
                                        </svg>
                                    </span>
                                </a>
                            )}

                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};

export default VisitSection;
